import { NgModule } from '@angular/core';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../core/shared.module';
import { PipesModule } from '../pipes/pipes.module';
import { NotificationDetailsComponent } from './components/notification-details/notification-details.component';
import { NotificationsListViewComponent } from './components/notifications-list-view/notifications-list-view.component';
import { NotificationPopupComponent } from './dialogs/notification-popup/notification-popup.component';
import { NotificationsTabDialogComponent } from './dialogs/notifications-tab-dialog/notifications-tab-dialog.component';

@NgModule({
    declarations: [
        NotificationsTabDialogComponent,
        NotificationsListViewComponent,
        NotificationDetailsComponent,
        NotificationPopupComponent
    ],
    exports: [NotificationsTabDialogComponent, NotificationsListViewComponent],
    imports: [SharedModule, MaterialModule, PipesModule]
})
export class NotificationsModule {}
